import axios from "axios";

const openEmrinstance= axios.create({
  baseURL: process.env.REACT_APP_EMR_BASE || "https://emr.brainymed.com/chim/customapi/",
});

// ✅ RESPONSE INTERCEPTOR
openEmrinstance.interceptors.response.use(
  (response) => {
    // Instead of returning full Axios response object,
    // this returns ONLY the data portion.
    return response.data;
  },
  (error) => {
    // Handle errors globally if needed
    return Promise.reject(error);
  }
);

export default openEmrinstance;
